// This file is auto-generated - DO NOT EDIT - it will be overwritten. 

export const allRoles = {
	SystemAdminCustomers:"SystemAdminCustomers",
	CustomerAdmin:"CustomerAdmin",
	CustomerAdminLimitedManagerAccess:"CustomerAdminLimitedManagerAccess",
	NewsAdmin:"NewsAdmin",
	News:"News",
	LearningAdmin:"LearningAdmin",
	Learning:"Learning",
	SystemAdminLearning:"SystemAdminLearning",
	SystemAdminDeviceRegistry:"SystemAdminDeviceRegistry",
	Map:"Map",
	VehicleRegistryAdmin:"VehicleRegistryAdmin",
	VehicleRegistry:"VehicleRegistry",
	VehicleRegistry_Alarms:"VehicleRegistry_Alarms",
	VehicleRegistry_TransportAgency:"VehicleRegistry_TransportAgency",
	SystemEvents:"SystemEvents",
	Planning:"Planning",
	IssueReports:"IssueReports",
	IssueReportsAdmin:"IssueReportsAdmin",
	Assembly:"Assembly",
	AssemblyGlobalAccess:"AssemblyGlobalAccess",
	PartnerCustomers:"PartnerCustomers",
	Documents:"Documents",
	DocumentsAdmin:"DocumentsAdmin",
	Payslips:"Payslips",
	Deviation:"Deviation",
	CrisisManagement:"CrisisManagement",
	Violation:"Violation",
	ViolationAdmin:"ViolationAdmin",
	ReadVehicleReports:"ReadVehicleReports",
	ReadUserReports:"ReadUserReports",
	ReportsAdmin:"ReportsAdmin",
	BkyAdmin:"BkyAdmin",
	BkyDriver:"BkyDriver",
}
